import config from "@Config/index";

type SuggestionPlace = {
  name?: string;
  name_zh?: string;
  name_en?: string;
};

/**
 * China search chips render as "中文 (English)".
 * A zh region response already translates `name`, so the English form is `name_en`.
 * Suggestion config keeps English on `name`. Omit the bracket when both sides match.
 */
const formatSearchSuggestionLabel = (
  place: SuggestionPlace = {},
  isChinaApp: boolean = config.IS_CHINA_APP,
): string => {
  const name = place.name?.trim() || "";
  const nameZh = place.name_zh?.trim() || "";

  if (!isChinaApp || !nameZh) return name;

  const englishName = place.name_en?.trim() || (name !== nameZh ? name : "");
  if (englishName && englishName !== nameZh) {
    return `${nameZh} (${englishName})`;
  }
  return nameZh;
};

export default formatSearchSuggestionLabel;
